import { Component, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-seller-profile',
  templateUrl: './seller-profile.component.html',
  styleUrls: ['./seller-profile.component.scss']
})
export class SellerProfileComponent {
  @Input() form!: FormGroup;
  @Input() userProfile: any;
  @Input() years: any[] = [];
  @Input() roleList: any[] = [];
  @Input() selectedRoles: any[] = [];
  @Input() selectedYear: any;
  @Input() agreeFlag = false;
  @Input() countryFlag = false;
  @Input() isTaxUpdatFlag = false;
  @Input() isTaxFormMandate = false;
  @Input() selectedLanguage!: string;
  @Input() disableButton = false;

  @Output() fileChanged = new EventEmitter<any>();
  @Output() profileSubmit = new EventEmitter<boolean>();
  @Output() descriptionOpen = new EventEmitter<void>();
  @Output() agreeFlagChange = new EventEmitter<boolean>();

  onRolesChange(selectedRoles: any[]) {
    this.form.patchValue({ roles: selectedRoles });
  }

  onYearChange(selectedYear: any) {
    this.form.patchValue({ ciscoSalesExperience: selectedYear.value });
  }

  openPdf() {
    window.open('https://sellerrewards-datahandler.cisco.com/shared/files/seller-rewards.pdf', '_blank');
  }

  partnerSelfService() {
    window.open('https://www.cisco.com/go/pss', '_blank');
  }
}
